module.exports = __webpack_public_path__ + "static/img/report3D_cover_3.356e9f08.png";